import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { PaymentRankItem } from '../payment-rank-interface';
import { ToastService } from 'fi-ui-common';
import { AddPaymentRank, DeletePaymentRank, FetchPaymentRanks, UpdatePaymentRank } from './payment-rank-actions';

export interface PaymentRankStoreModel {
  paymentRanks: PaymentRankItem[];
}

@State<PaymentRankStoreModel>({
  name: 'paymentRankState',
  defaults: {
    paymentRanks: []
  }
})

@Injectable()
export class PaymentRankState {
  private http = inject(HttpClient);
  private toast = inject(ToastService);

  @Selector()
  static getPaymentRanks(state: PaymentRankStoreModel) {
    return state.paymentRanks;
  }

  @Action(AddPaymentRank)
  addPaymentRank({getState, patchState}: StateContext<PaymentRankStoreModel>, { paymentRank }: AddPaymentRank): Observable<PaymentRankItem> {
    return this.http.post<PaymentRankItem>(`service/paymentRank`, paymentRank).pipe(
      tap(data => {
        patchState({ paymentRanks: [...getState().paymentRanks, data] });
        this.toast.onSuccess('Added successfully');
      })
    );
  }

  @Action(UpdatePaymentRank)
  updatePaymentRank({getState, patchState}: StateContext<PaymentRankStoreModel>, { paymentRank }: UpdatePaymentRank): Observable<PaymentRankItem> {
    return this.http.put<PaymentRankItem>(`service/paymentRank`, paymentRank).pipe(
      tap(data => {
        patchState({ paymentRanks: getState().paymentRanks.map(r => r.id === data.id ? data : r) });
        this.toast.onSuccess('Updated successfully')
      })
    );
  }

  @Action(DeletePaymentRank)
  deletePaymentRank({getState, patchState}: StateContext<PaymentRankStoreModel>, { id }: DeletePaymentRank): Observable<any> {
    return this.http.delete<any>(`service/paymentRank/${id}`).pipe(
      tap(() => {
        patchState({ paymentRanks: getState().paymentRanks.filter(r => r.id !== id) });
        this.toast.onSuccess('Deleted successfully')
      })
    )
  }

  @Action(FetchPaymentRanks)
  fetchPaymentRanks({patchState}: StateContext<PaymentRankStoreModel>): Observable<PaymentRankItem[]> {
    return this.http.get<PaymentRankItem[]>(`service/paymentRanks`).pipe(
      tap(paymentRanks => patchState({paymentRanks}))
    );
  }
}
